import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/instances';
import { actionCreators as actionCreatorsRegisters }  from '../actions/registers';
import { actionCreators as actionCreatorsEvents }  from '../actions/events';
import DashboardTableItem from './DashboardTableItem';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import '../styles/DashboardTable.css';
import {getToken} from '../adalConfig';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

import {
  Table,
  TableHead,
  TableBody,
  Button,
  TextField
} from "@material-ui/core";

class DashboardTableComponent extends Component {
  
  constructor(props) {
    super(props);
    this.state ={
        open: false,
        tagSelected: undefined,
        note: ''
    }
}

getHeader = (registerTag) => {
   if(registerTag.includes("error")){
    registerTag = registerTag.replace("latest", "latest ");
   }else if(registerTag.includes("instance-latest-well-update-datetime")){
    registerTag = registerTag.replace("instance-latest-well-update-datetime", "well-update-datetime");
  }else if(registerTag.includes("instance-latest-installation-update-datetime")){
    registerTag = registerTag.replace("instance-latest-installation-update-datetime", "Installation-update-datetime");
  }else if(registerTag.includes("latest")){
    registerTag = registerTag.replace("well-latest", "latest ");
  }else if(registerTag.includes("license")){
    registerTag = registerTag.replace("license", "license ");
  }
  if(registerTag.includes("instance-")){
    registerTag = registerTag.replace("instance-", "");
  }
  var header = registerTag.charAt(0).toUpperCase() + registerTag.substr(1).replace(/-/g,' ');
  return header;
  };


handleClickOpen = (e) => {
  this.setState({open: true, tagSelected: e})
  };

  handleClose = (e) => {
    this.setState({open: false, tagSelected: e})
    };

    onChangeNote = (e) => {
      const note = e.target.value;
      this.setState(() => ({note}));
      };

    handleAcknowledge = (e) => {
      const event = {
        summary: this.state.note,
        instanceId: this.state.tagSelected.instanceId, 
        tag : this.state.tagSelected.tag
      };
      this.setState({open: false, tagSelected: e});
      this.props.addEvent(event).then(() => { 
        this.props.requestInstances();
        this.props.requestEvents();
      });
    }


  _tick = () => {
    this.props.requestInstances();
  }

  _tick2 = () => {
    const headers = { Authorization: `Bearer ${getToken()}` };
    fetch('/api/user/current', { headers })
      .then(response => {
        if (response.ok) {
          window.location.reload()
        } else {  
          window.location.reload()
        }
      });
  }
 
  componentDidMount(){
    this.props.requestRegisterTags();
    //this.props.requestInstances();
    this.timer = setInterval(this._tick2, 1200000);
    this.timer = setInterval(this._tick, 60000);
    
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderDashboardTable = (props) => {
    if(this.props.instances !== undefined || this.props.instances !== []){
    return (
      <div style={{scrollX:'auto'}} className="DashboardTable-Wrapper">
        <Table style={{padding:'10%', scrollX:'auto'}} className="mb-0">
        <TableHead>
          <tr
            style= {
              {
                fontSize: '1.3rem',
                fontWeight: 'normal'
              }}
          >
            <th>Client</th>
            {this.props.registerTags.map( (registerTag) => {
            return (
              <th style={{textAlign: 'center'}} key={registerTag}>
                {this.getHeader(registerTag)}
              </th>
            )
          })}
          </tr>
        </TableHead>
        <TableBody>
          {
            this.props.instances.map(i => {
            return (
              <TableRow id={i.id+"row"}>
                <TableCell
                  id = {i.name + i.id}
                  style= {
                    {
                      fontSize: '1.4rem',
                      fontFamily: 'Open Sans',
                      color: 'black'
                    }}
                >
                  <a href={'https://'+i.url} target="_blank">{i.name}</a> 
                </TableCell>
                {this.props.registerTags.map(tag => {
                  return(
                  <DashboardTableItem id={i.id+tag} key={i.id+tag} registerTag={tag} instance={i} openDialog={this.handleClickOpen} history={this.props.history} isExtended={this.props.isExtended} />
                  )
                })}
              </TableRow>
            )
          })}
        </TableBody>
        </Table>
      </div>
    );
    }else{
      return (<h3 className="DashboardH1">No instances data found.</h3>);
    }
  }

  render() {
    return (
      <div>
      <Dialog
      open={this.state.open}
      onClose={this.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
<DialogTitle id="alert-dialog-title"> {"Acknowledge Critical Alert - "} {this.state.tagSelected !== undefined ? this.state.tagSelected.tag : ''}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
        <h3>Tag:</h3>
        <Typography variant="body1" color="textSecondary" component="p">
            {this.state.tagSelected !== undefined ? this.state.tagSelected.tag : ''}
        </Typography>
        </DialogContentText>
        <TextField
            autoFocus
            margin="dense"
            id="note"
            label="Note"
            defaultValue= {this.state.tagSelected !== undefined && this.state.tagSelected.event !== null && this.state.tagSelected.event !== undefined ? this.state.tagSelected.event.description + ' - ' + this.state.tagSelected.event.summary : ''}
            type="text"
            fullWidth
            multiline
            onChange={this.onChangeNote}
            InputProps={{
              readOnly: this.state.tagSelected !== undefined ? this.state.tagSelected.isAcknowledged : false,
            }}
          />
      </DialogContent>
      <DialogActions>
          <Button variant="contained" onClick={this.handleClose} color="secondary">
            Close
          </Button>
          <Button variant="contained" onClick={this.handleAcknowledge} color="primary" disabled={this.state.tagSelected !== undefined && this.state.tagSelected.isAcknowledged ? 'disabled' : ''}>
            Acknowledge
          </Button>
        </DialogActions>
    </Dialog>
      
        <h1 className="DashboardH1">Dashboard</h1>
        {this.renderDashboardTable(this.props)}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  requestInstances: () => dispatch(actionCreators.requestInstances()),
  requestRegisterTags: () => dispatch(actionCreatorsRegisters.requestRegisterTags(props.isExtended)),
  addEvent: (event) => dispatch(actionCreatorsEvents.addEvent(event)),
  requestEvents: () => dispatch(actionCreatorsEvents.requestEvents())
});

function mapStateToProps(state) {
  return {
      instances: state.instances.instances,
      registerTags: state.registers.registerTags
  };
}
const DashboardTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardTableComponent);

export default DashboardTable;


// WEBPACK FOOTER //
// ./src/components/DashboardTable.js